const {CopyToClipboard} = require('./Component');

module.exports = CopyToClipboard;
